import useTheme from '../hooks/useTheme';

export const useGetThemeVersion = () => {
  const { version } = useTheme();
  return version;
};
